<template>
  <div
    id="providers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >
              <v-col
                cols="12"
                md="10"
              >
                <v-text-field
                  v-model="form.username"
                  :rules="[rules.required, rules.Length]"
                  label="Usuario de Integranción"
                  maxlength="50"
                  placeholder="EJEMPLO_INT"
                  @change="searchUsername"
                  required
                />
              </v-col>
              <v-col
                cols="12"
                md="10"
              >
                <v-text-field
                  v-model="form.email"
                  :rules="[rules.required, rules.emailFormat]"
                  maxlength="100"
                  label="Correo Electrónico"
                  placeholder="ejemplo@dominio.com"
                />
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Form from 'vform';
  import FormToolbar from '~/components/Form/Toolbar';

  export default {
    components: {
      FormToolbar,
    },
    props: {
      enterpriseId: { default: '' },
      id: { default: '' },
    },
    data: () => ({
      form: new Form({
        id: '',
        username: '',
        email: '',
        usertype: 'ws',
        active: '1',
        busy: false,
      }),
      usertypes: [
        { value: 'portal', text: 'Portal' },
        { value: 'ws', text: 'Web Services' },
        { value: 'apk', text: 'APP Móvil' },
      ],
      valid: false,
      searching: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        Length: (v) => (v.length > 8 && v.length <= 50) || 'El campo debe tener de 8 a 50 caracteres.',
        emailFormat: (v) => /.+@.+\..+/.test(v) || 'El campo debe tener un correo electrónico válido.',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Nuevo Usuario de Integración',
      apiURL: '/api/enterprises',
      apiURLIntegration: 'users-integrations/store',
      method: 'POST',
    }),
    computed: {
      ref() { return this.form.id; },
    },
    async mounted() {
      const URL = `${this.apiURL}/${this.enterpriseId}/${this.apiURLIntegration}`;
      this.URL = URL;
      if (this.id) {
        window.axios.get(`/api/enterprises/${this.enterpriseId}/users-integrations/${this.id}`)
        .then((result) => {
          Object.assign(this.form, result.data);
          this.URL = `/api/enterprises/${this.enterpriseId}/users-integrations/${this.id}/update`;
          this.method = 'PUT';
          this.title = 'Editar Usuario de Integración';
          this.message = `Se ha editado el usuario de integrancion ${result.data.username} exitosamente.`;
        });
      }
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.form.busy = true;
          this.store();
        }
      },
      store() {
        window.axios({
          method: this.method,
          url: this.URL,
          data: this.form,
        })
        .then(() => {
         this.$router.go(-1);
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      reset() {
        this.$refs.form.reset();
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
      searchUsername() {
        if (this.form.username) {
          const url = `${this.apiURL}/${this.enterpriseId}/users-integrations/getIntegration/${this.form.username}`;
          window.axios.get(url)
          .then((response) => {
            if (response.data.code === 500) {
              this.form.username = '';
            }
            this.$store.dispatch('notifications/show', {
              message: response.data.message,
              type: response.data.type,
            });
          });
        }
      },
    },
  };

</script>
